import { toast } from "react-toastify";
const success = (message, options) => {
    options = {
        autoClose: (options === null || options === void 0 ? void 0 : options.autoClose) || 1500,
        hideProgressBar: true,
        pauseOnFocusLoss: false,
    };
    toast(message, Object.assign({ type: "success" }, options));
};
const error = (message, options) => {
    options = {
        autoClose: (options === null || options === void 0 ? void 0 : options.autoClose) || 2000,
        hideProgressBar: true,
        pauseOnFocusLoss: false,
    };
    toast(message, Object.assign({ type: "error" }, options));
};
const info = (message, options) => {
    options = {
        autoClose: (options === null || options === void 0 ? void 0 : options.autoClose) || 2000,
        hideProgressBar: true,
        pauseOnFocusLoss: false,
    };
    toast(message, Object.assign({ type: "info" }, options));
};
export const ToastUtils = {
    success,
    error,
    info,
};
